import styled from "styled-components";
import { FlexContainer, FlexDiv, FlexSection } from "@/components/Atoms/Box";
import StyledSvgSprite from "@/components/Atoms/SVGSprite";
import Typography from "@/foundation/Typography/V2";
import { LHSBox } from "../HeroSection/style";

export const Wrapper = styled(FlexSection)`
  padding: 40px 0 80px;
  @media only screen and (max-width: 992px) {
    padding: 24px 0 48px;
  }
`;
export const Container = styled(FlexContainer)`
  align-items: flex-start;
  @media only screen and (max-width: 992px) {
    flex-direction: column;
  }
`;

export const StyledLHSBox = styled(LHSBox)`
  position: sticky;
  top: 80px;
  @media only screen and (max-width: 992px) {
    position: static;
    justify-content: center;
    min-height: unset;
  }
`;

export const RHSBox = styled(FlexDiv)`
  max-width: 57.9%;
  width: 100%;
  flex-direction: column;
  padding: 8px;
  @media only screen and (max-width: 1169px) {
    max-width: 50%;
  }
  @media only screen and (max-width: 992px) {
    max-width: 100%;
  }
`;
export const Attributes = styled(FlexDiv)`
  padding: 24px 24px 16px;
  background-color: ${({ theme }) => theme.colorsV2.primary.shade_50};
  width: 100%;
  border-radius: 24px;
  flex-direction: column;
  margin-bottom: 32px;
`;
export const AttributeItemBox = styled(FlexDiv)`
  flex-wrap: wrap;
`;
export const AttributeItem = styled(Typography)`
  margin: 0 16px 8px 0;
  color: ${({ theme }) => theme.colorsV2.gray.shade_700};
  display: flex;
  align-items: center;
  font-size: 16px;
  line-height: 24px;
`;
export const AttributeHeading = styled(Typography)`
  margin-bottom: 16px;
  color: ${({ theme }) => theme.colorsV2.gray.shade_700};
`;
export const CheckMarkIcon = styled(StyledSvgSprite)`
  fill: ${({ theme }) => theme.colorsV2.success.shade_600};
  height: 16px;
  width: 16px;
  margin-right: 8px;
`;
export const IngredientWrapper = styled(FlexDiv)`
  padding: 8px 8px 0 8px;
  width: 100%;
  flex-direction: column;
`;
export const IngredientBox = styled(FlexDiv)`
  flex-wrap: wrap;
  margin: 0 -8px;
  @media only screen and (max-width: 399px) {
    max-width: 100%;
    margin: 0;
  }
`;
export const IngredientItem = styled(Typography)`
  margin: 0 8px 16px 8px;
  width: 100%;
  max-width: calc(50% - 16px);
  color: ${({ theme }) => theme.colorsV2.gray.shade_800};
  padding-left: 32px;
  position: relative;
  &:before {
    content: "";
    height: 5px;
    width: 5px;
    border-radius: 50%;
    background-color: ${({ theme }) => theme.colorsV2.gray.shade_800};
    position: absolute;
    top: 10px;
    left: 10px;
  }
  @media only screen and (max-width: 399px) {
    max-width: 100%;
    margin: 0 0 16px;
  }
`;
export const MethodList = styled(Typography)`
  margin-bottom: 24px;
  color: ${({ theme }) => theme.colorsV2.gray.shade_800};
  &:last-child {
    margin-bottom: 0px;
  }
  strong,
  b {
    font-family: var(--man-700);
    font-size: inherit;
    color: inherit;
    line-height: inherit;
    display: block;
    width: 100%;
    margin-bottom: 24px;
    &.inline-block {
      margin-bottom: 0px;
      display: inline-block;
      width: auto;
      margin-right: 3px;
    }
  }
`;
export const MethodBox = styled(FlexDiv)`
  flex-direction: column;
`;
export const MobileDiv = styled(FlexDiv)`
  flex-direction: column;
  width: 100%;
  margin-bottom: 32px;
`;
